import { useEffect } from "react";

type ShortcutOptions = {
  ctrl?: boolean;
  alt?: boolean;
  shift?: boolean;
  key: string;
  action: () => void;
};

export function useKeyboardShortcut({
  ctrl,
  alt,
  shift,
  key,
  action,
}: ShortcutOptions) {
  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (
        !!ctrl === event.ctrlKey &&
        !!alt === event.altKey &&
        !!shift === event.shiftKey &&
        event.key.toLowerCase() === key.toLowerCase()
      ) {
        action();
      }
    };

    window.addEventListener("keydown", handler);

    return () => window.removeEventListener("keydown", handler);
  }, [ctrl, alt, shift, key, action]);
}
